import {gsap} from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import {tweens_arrays_apparition as tween_big_title} from '../../../miscellaneous/bigTitle'
window.$ = window.jQuery = require('jquery');
gsap.registerPlugin(DrawSVGPlugin);

const animationEnter = (container) => {
    console.log("default animation enter");
    const featured_image = $(container).find('#featured-image').first();
    const menu = $(container).find("#nav-wrapper").first();
    const page_title = $(container).find("#page-title").first();
    const intro_text = $(container).find("#intro-texte").first();
    const gribouille = $(container).find("#gribouille").first();
    const tl = gsap.timeline({
        defaults : {
            duration: .5,
            ease: "power1.out",
        }
    });
    tl.set(gribouille, {drawSVG:0, autoAlpha:1});
    // S'il y a une image mise en avant on la cache pour l'animer par la suite
    if(featured_image.length){
        tl.set(featured_image, {y:"-160%", alpha:1});
    }


    tl.add(tween_big_title)
        .from([page_title,menu, intro_text], {autoAlpha:0});
    // Animation de l'image mise en avant
    if(featured_image.length){
        tl.to(featured_image, {y:"0%", ease: "power3.out", duration:1.4}, '-=0.65');
    }

    tl.to("#gribouille", {drawSVG:true, duration:1, ease: "power1.out"});

    return tl;
}

export default animationEnter;